import {Client} from '../../../graphql/types'

const KUWAIT_IB_IDS = [10512, 10544, 10543, 10542, 10508]

const isDebug = () => {
  try {
    return localStorage.getItem('logs') === '1'
  } catch {
    return false
  }
}

export const overrideForKuwaitNetwork = (accounts: any[], client: Client) => {
  const debug = isDebug()

  if (!client?.metadata) {
    if (debug) console.log('[KuwaitNetwork] No client metadata, skipping override')
    return accounts
  }

  let metadata: any
  try {
    metadata =
      typeof client.metadata === 'string' ? JSON.parse(client.metadata) : client.metadata
  } catch (err) {
    console.warn('Failed to parse metadata:', client.metadata)
    return accounts
  }

  const remoteIbId = metadata?.ibFollowerData?.remoteIbId

  if (!KUWAIT_IB_IDS.includes(remoteIbId)) {
    if (debug) console.log('[KuwaitNetwork] IB ID %d is not in Kuwait network, skipping', remoteIbId)
    return accounts
  }

  const KUWAIT_IB_IDS_WITH_DEMO = [10512, 10508]
  const hasDemoAccess = KUWAIT_IB_IDS_WITH_DEMO.includes(remoteIbId)

  const allowedSubtypes = hasDemoAccess
    ? ['mt5Std', 'black', 'mt5StdDemo']
    : ['mt5Std', 'black']

  if (debug) {
    console.log('[KuwaitNetwork] IB ID: %d, demo access: %s, allowed subtypes: %o', remoteIbId, hasDemoAccess, allowedSubtypes)
    console.log('[KuwaitNetwork] Input accounts:', accounts.map((a) => ({subtype: a.accountSubtype, category: a.category})))
  }

  // Kuwait Network: only allow MT5 standard and black trading accounts, hide others and all affiliate accounts.
  const filtered = accounts.filter(
    (account) =>
      allowedSubtypes.includes(account.accountSubtype) &&
      account.category !== 'affiliate',
  )

  if (debug) {
    console.log('[KuwaitNetwork] Output accounts:', filtered.map((a) => ({subtype: a.accountSubtype, category: a.category})))
  }

  return filtered
}

